import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-in', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/stock-in/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/stock-in', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/stock-in/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/stock-in/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toPdf = id => {
  return httpClient
    .get(`/api/v1/stock-in/${id}/to-pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const supplier = () => {
  return httpClient
    .get('/api/v1/stock-in/suppliers')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const location = () => {
  return httpClient
    .get('/api/v1/stock-in/locations')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (attrubutes = {}) => {
  return httpClient
    .get('/api/v1/stock-in/products', attrubutes)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const purchaseorder = (attrubutes = {}) => {
  return httpClient
    .get('/api/v1/stock-in/purchase-orders', attrubutes)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const purchaseorderList = (po_id, location_id) => {
  return httpClient
    .get(`/api/v1/stock-in/purchase-orders/${po_id}/${location_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const vendor = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-in/vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const purchaseType = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-in/purchase-types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-in/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  supplier,
  location,
  product,
  purchaseorder,
  purchaseorderList,
  toPdf,
  vendor,
  purchaseType,
  formViewModel
}
